module.exports = __webpack_public_path__ + "VAGRoundedStd-Thin.dbaed83af6dbe0d753f9.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.svg
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Thin.svg
// module chunks = styles